<template>
  <h-slug :to="link" class="link-animate fz-link" data-comp="a-link-line-arrow">
    <span class="link-animate__line"></span>
    <span class="link-animate__text">{{ text }}</span>
    <span class="ssr-only">{{ description }}</span>
    <i-arrow-outward class="link-animate__arrow" v-if="icon === 'outward'" />
    <i-arrow-forward class="link-animate__arrow" v-else />
  </h-slug>
</template>

<script setup>
defineProps({
  link: {
    type: Object,
  },
  text: {
    type: String,
    default: "",
  },
  description: {
    type: String,
    default: "",
  },
  icon: {
    type: String,
    default: "",
  },
});
</script>

<style lang="scss" scoped>
.link-animate {
  display: flex;
  align-items: center;
  &__line {
    content: "";
    width: 30px;
    height: 1px;
    background-color: var(--color-txt-secondary);
    transform-origin: left center;
    transform: scaleX(0);
    @include global.transition(transform 0.5s global.$ease-in-cubic);
    .link-animate:hover & {
      transform: scaleX(1);
    }
  }
  &__text {
    transform: translateX(-40px);
    transform-origin: left center;
    white-space: nowrap;
    margin-left: 10px;
    margin-right: 10px;
    @include global.transition(transform 0.5s global.$ease-in-cubic);
    .link-animate:hover & {
      transform: translateX(0px);
    }
  }
  &__arrow {
    width: 15px;
    transform: translateX(-46px);
    transform-origin: left center;
    opacity: 1;
    @include global.transition(transform 0.5s global.$ease-in-cubic);
    .link-animate:hover & {
      transform: translateX(0px);
    }
  }
}
</style>
